const helpers = require('./helpers');
const paymentMethods = require('../paymentMethods/paymentMethods');
const getPaymentMethodName = require('../paymentMethods/getPaymentMethodName');
const getPaymentMethodTitle = require('../paymentMethods/getPaymentMethodTitle');
const getAmountPaid = require('../paymentMethods/getAmountPaid');
const ventilateAmountTotalByTva = require('./ventilateAmountTotalByTva');
const { transferQuantity } = require('./transferQuantity');
const formatItems = require('./formatItems');
const arePaymentsDone = require('./arePaymentsDone');

module.exports = {
  calculateAmountTotalFromItems: helpers.calculateAmountTotalFromItems,
  ventilateAmountTotalByTva,
  arePaymentsDone,
  formatItems,
  getAmountPaid,
  getPaymentMethodTitle,
  getPaymentMethodName,
  transferQuantity,
  calculateUnitsTotalFromItems: helpers.calculateUnitsTotalFromItems,
  calculateTVARateFromItems: helpers.calculateTVARateFromItems,
  getPaymentMethods: () => paymentMethods,
  getProducerProductIds: helpers.getProducerProductIds
};